"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dotToneTokens = exports.dotToneColor = exports.dotToneColors = exports.dotBelowStyles = exports.dotStyles = exports.dotSizeTokens = exports.dotSizes = void 0;
const lit_1 = require("lit");
const tag_styles_1 = require("@/components/common/tag/tag.styles");
/** 점이 갖는 크기 단계. 점을 조합하는 컴포넌트도 이 안에서만 크기를 고른다. */
exports.dotSizes = {
    '16': 'var(--size-16)',
    '12': '12px',
    '8': '8px',
    '6': '6px',
};
exports.dotSizeTokens = Object.fromEntries(Object.entries(exports.dotSizes).map(([size, value]) => [size, { '--dot-size': value }]));
/**
 * 점의 모양과 크기. 점을 그리는 선택자 안에 펼쳐 쓴다.
 * 색은 --dot-background-color 하나로 모이므로, 상태별로 달라질 때도 이 변수에 값을 다시 할당한다.
 */
exports.dotStyles = (0, lit_1.css) `
  --dot-size: ${(0, lit_1.unsafeCSS)(exports.dotSizes['8'])};
  --dot-background-color: var(--foreground-subtle-color);

  display: inline-block;
  flex-shrink: 0;
  width: var(--dot-size);
  height: var(--dot-size);
  border-radius: 50%;
  background-color: var(--dot-background-color);
`;
/**
 * 가로로 늘어선 항목에서 현재 위치를 가리키는 점을 항목 아래 가운데에 띄운다. 점 선택자 안에 펼쳐 쓴다.
 * 흐름 밖에 두어 현재 항목만 높이가 달라지지 않게 하며, 항목이 position 기준이 된다.
 */
exports.dotBelowStyles = (0, lit_1.css) `
  position: absolute;
  top: 100%;
  left: 50%;
  translate: -50% 0;
`;
const tagToneColors = Object.fromEntries(Object.entries(tag_styles_1.tagToneStyles).map(([tone, { borderColor }]) => [tone, borderColor]));
/**
 * 점은 면이 작아 배경 틴트로는 색이 드러나지 않는다. tag의 tone은 테두리로 쓰는 값을 채우고,
 * gray는 tag에 없는 점 전용 tone으로 진한 회색을 채운다.
 */
exports.dotToneColors = {
    ...tagToneColors,
    gray: 'var(--background-strong-color)',
};
const dotToneColor = (tone) => exports.dotToneColors[tone];
exports.dotToneColor = dotToneColor;
const dotToneTokens = (tone) => ({ '--dot-background-color': (0, exports.dotToneColor)(tone) });
exports.dotToneTokens = dotToneTokens;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG90LnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImRvdC5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQW9DO0FBRXBDLG1FQUFnRjtBQUVoRixpREFBaUQ7QUFDcEMsUUFBQSxRQUFRLEdBQUc7SUFDdEIsSUFBSSxFQUFFLGdCQUFnQjtJQUN0QixJQUFJLEVBQUUsTUFBTTtJQUNaLEdBQUcsRUFBRSxLQUFLO0lBQ1YsR0FBRyxFQUFFLEtBQUs7Q0FDRixDQUFBO0FBSUcsUUFBQSxhQUFhLEdBQUcsTUFBTSxDQUFDLFdBQVcsQ0FDN0MsTUFBTSxDQUFDLE9BQU8sQ0FBQyxnQkFBUSxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsWUFBWSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FDakYsQ0FBQTtBQUVEOzs7R0FHRztBQUNVLFFBQUEsU0FBUyxHQUFHLElBQUEsU0FBRyxFQUFBO2dCQUNaLElBQUEsZUFBUyxFQUFDLGdCQUFRLENBQUMsR0FBRyxDQUFDLENBQUM7Ozs7Ozs7OztDQVN2QyxDQUFBO0FBRUQ7OztHQUdHO0FBQ1UsUUFBQSxjQUFjLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7O0NBS2hDLENBQUE7QUFFRCxNQUFNLGFBQWEsR0FBRyxNQUFNLENBQUMsV0FBVyxDQUN0QyxNQUFNLENBQUMsT0FBTyxDQUFDLDBCQUFhLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFLFdBQVcsRUFBRSxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsSUFBSSxFQUFFLFdBQVcsQ0FBQyxDQUFDLENBQ3pELENBQUE7QUFFNUI7OztHQUdHO0FBQ1UsUUFBQSxhQUFhLEdBQUc7SUFDM0IsR0FBRyxhQUFhO0lBQ2hCLElBQUksRUFBRSxnQ0FBZ0M7Q0FDdkMsQ0FBQTtBQUlNLE1BQU0sWUFBWSxHQUFHLENBQUMsSUFBYSxFQUFFLEVBQUUsQ0FBQyxxQkFBYSxDQUFDLElBQUksQ0FBQyxDQUFBO0FBQXJELFFBQUEsWUFBWSxnQkFBeUM7QUFFM0QsTUFBTSxhQUFhLEdBQUcsQ0FBQyxJQUFhLEVBQUUsRUFBRSxDQUFDLENBQUMsRUFBRSx3QkFBd0IsRUFBRSxJQUFBLG9CQUFZLEVBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO0FBQXJGLFFBQUEsYUFBYSxpQkFBd0UifQ==